export let Events;
(function (Events) {
  Events["LABEL_FIRST_INPUT_DELAY"] = "first-input-delay";
  Events["LABEL_TIME_TO_FIRST_BYTE"] = "time-to-first-byte";
  Events["LABEL_TIME_TO_INTERACTIVE"] = "time-to-interactive";
  Events["LABEL_TIME_TO_FIRST_CONTENTFUL_PAINT"] = "first-contentful-paint";
  Events["LABEL_TIME_TO_LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
  Events["LABEL_CUMULATIVE_LAYOUT_SHIFT"] = "cumulative-layout-shift";
  Events["LABEL_TIME_TO_FIRST_MEANINGFUL_PAINT"] = "first-meaningful-paint";
  Events["LABEL_RESOURCE_DOWNLOAD_TIME_SUM"] = "resource-download-time-sum";
  Events["LABEL_CAAS_SPI_METHOD_EXECUTION"] = "caas-spi-execution";
  Events["LABEL_ALGOLIA_SEARCH_TIMING"] = "algolia-search";
  Events["LABEL_COMPONENT_ERROR_BOUNDARY"] = "component-error-boundary";
  Events["LABEL_GENERIC_TASK"] = "generic-task";
  Events["LABEL_PAGE_VIEW_TASK"] = "page-view-task";
  Events["LABEL_ROUTE_CHANGE_START"] = "route-change-start";
})(Events || (Events = {}));